<template>
  <div>
    <!-- mensajes de confirmacion -->
    <mensajeSistema></mensajeSistema>



    <!-- consultar -->
    <v-row>
      <v-col cols="12">
        <v-autocomplete label="Estado" v-model="filtro.estado" :items="lista_filtro_estados" item-value="id"
          item-text="text" @change="changeFiltroEstado()" autocomplete="off" style="max-width:200px">
        </v-autocomplete>
      </v-col>
      <v-col cols="12">
        <ComundataTablecomp :headers="PagosHeaders" :items="listItems" :search="search" item-key="id_asig_movimiento_pago"
          v-model="selectedItems" whitSelect unselectable :loading="loading">
          <template v-slot:fecha_vencimiento="{ item }">{{ item.fecha_vencimiento | filtroFecha }}</template>
          <template v-slot:estado="{ item }">
            <ButtonComp :class-color="item.estado == 'PAGADO' ? 'success' : 'red'" @click="return false;"
              :text-button="item.estado" />

          </template>
          <template v-slot:pago_efectivo="{ item }">
            <span class="btn_pago_efectivo v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--x-small" x-small>
              PAGO EFECTIVO
            </span>
          </template>

          <template v-slot:verpago="{ item }">
            <ButtonComp v-if="item.estado == 'PAGADO'" @click="showBoleta(item)" verButton
              tooltip-text="Ver boleta electrónica" />

          </template>
        </ComundataTablecomp>

      </v-col>
    </v-row>



  </div>
</template>

<script>
import axios from "../../../../helpers/axios";
import CommonRules from "../../commonRules";
import { mapMutations, mapGetters, mapActions } from "vuex";
import ComundataTablecomp from '../../../../components/ComponentsEst/ComundataTablecomp.vue';
import ButtonComp from '../../../../components/ComponentsEst/TableButtonComp.vue';
import { PagosHeaders } from '../../../../helpers/headersTable';

export default {
  components: {
    ComundataTablecomp,
    ButtonComp
  },
  data: () => ({
    paramComponente: { id_submodulo: 2, id_modulo: 4 },
    dataSession: sessionStorage,
    PagosHeaders,
    selectedItems: [],
    showDialog: false,
    btnIsSaving: false,
    loading: false,
    filtro: {
      estado: null
    },
    search: "",
    confirm: {
      id: 0,
      title: "",
      active: false,
    },

    rul: CommonRules(),
    listItems: [],
    lista_filtro_estados: [{ id: "PENDIENTE", text: "PENDIENTE" }, { id: "PAGADO", text: "PAGADO" }],
    isNew: true,
    editedItem: {},
  }),

  computed: {
    formTitle() {
      return this.isNew ? "Registro de Deuda" : "Editar Registro de Deuda";
    },

    ...mapGetters("login", ["componenteEvento"]),
  },
  mounted() {
    this.getListaPagoPagos();
  },

  created() {
    this.actualizarParamentro();
  },

  methods: {
    ...mapActions("login", ["parametroComponente"]),

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },

    ...mapMutations("mensajeSis", ["setEnviarMens"]),

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    async changeFiltroEstado() {
      await this.getListaPagoPagos();
    },

    showBoleta(item) {
      console.log(item);
      window.open(item.url_boleta, '_BLANK');
    },

    async getListaPagoPagos() {
      this.selectedItems = [];
      this.loading = true;
      this.filtro["id_colegio"] = this.dataSession.id_colegio;
      await axios
        .post("/tesoreria/pago/pagos/consulta", this.filtro)
        .then((response) => {
          this.listItems = response.data;
          this.loading = false;
        }).catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e.error}`, tiempo: null });
          this.loading = false;
        });
    },
  },
};
</script>
